import React from "react";
import Menu from "../../components/ui/Menu";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";

function TermsAndCondition(props) {
  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };
  return (
    <div>
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Terms" setShowMenu={props.setShowMenu} />
      <div
        style={{
          padding: "20px",
          paddingTop: "120px",
          paddingBottom: "120px",
          margin: "20px",
          borderRadius: "10px",
        }}
      >
        <h1 style={{ marginBottom: "20px", textAlign: "left" }}>
          Terms and Conditions for MyAgentPro
        </h1>
        <p style={{ marginBottom: "10px", textAlign: "left" }}>
          Effective Date: 12th of November, 2024.
        </p>
        <p style={{ textAlign: "left" }}>
          Welcome to MyAgentPro ("we", "us", "our"). These Terms and Conditions
          ("Terms") govern your access to and use of our mobile application
          ("App") and any related services provided by AgentPro Technology
          Businesses ("the Company"). By downloading, installing, or using the
          App, you agree to comply with and be bound by these Terms. If you do
          not agree with these Terms, please do not use the App.
        </p>
        <ol
          style={{
            listStyleType: "decimal",
            marginLeft: "20px",
            textAlign: "left",
          }}
        >
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Acceptance of Terms
            </h2>
            <p style={{ textAlign: "left" }}>
              By accessing or using the App, you acknowledge that you have read,
              understood, and agree to be bound by these Terms, as well as our
              Privacy Policy, which is incorporated by reference. If you do not
              agree with any part of these Terms, you must immediately stop
              using the App.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              User Eligibility
            </h2>
            <p style={{ textAlign: "left" }}>
              You must be at least 18 or older to use this App. By agreeing to
              these Terms, you represent that you meet the eligibility
              requirements and are legally able to enter into a binding
              contract.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Account Registration and Security
            </h2>
            <p style={{ textAlign: "left" }}>
              To use certain features of the App, you may be required to create
              an account. You agree to provide accurate, complete, and
              up-to-date information during the registration process. You are
              solely responsible for maintaining the confidentiality of your
              account credentials and for any activity that occurs under your
              account. Notify us immediately if you believe your account has
              been compromised.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              License to Use the App
            </h2>
            <p style={{ textAlign: "left" }}>
              We grant you a non-exclusive, non-transferable, revocable license
              to access and use the App for personal, non-commercial purposes in
              accordance with these Terms. You may not copy, modify, distribute,
              sell, or reverse-engineer the App unless expressly authorized by
              us.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Prohibited Uses
            </h2>
            <p style={{ textAlign: "left" }}>
              You agree not to use the App for any unlawful or prohibited
              purposes, including but not limited to:
            </p>
            <ul
              style={{
                listStyleType: "disc",
                marginLeft: "20px",
                textAlign: "left",
              }}
            >
              <li>Violating any applicable laws or regulations.</li>
              <li>Infringing on the intellectual property rights of others.</li>
              <li>Distributing viruses, malware, or other harmful software.</li>
              <li>
                Attempting to gain unauthorized access to the App, other users'
                accounts, or our systems.
              </li>
              <li>
                Engaging in harassment, spamming, or other disruptive behavior.
              </li>
            </ul>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Data Collection and Privacy
            </h2>
            <p style={{ textAlign: "left" }}>
              We collect and process personal information in accordance with our
              Privacy Policy, which you should read to understand how we handle
              your data. By using the App, you consent to the collection and use
              of your data as described in the Privacy Policy.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Third-Party Services
            </h2>
            <p style={{ textAlign: "left" }}>
              The App may contain links to third-party websites, services, or
              content. We are not responsible for the availability, accuracy, or
              content of such third-party resources. You acknowledge that we are
              not liable for any damages or loss caused by your use of
              third-party websites or services.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Intellectual Property
            </h2>
            <p style={{ textAlign: "left" }}>
              All content and materials provided in the App, including but not
              limited to text, images, logos, graphics, software, and
              trademarks, are the property of AgentPro Technology Businesses or
              its licensors and are protected by copyright, trademark, and other
              intellectual property laws. You may not use any of our
              intellectual property without prior written consent.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Termination
            </h2>
            <p style={{ textAlign: "left" }}>
              We may suspend or terminate your access to the App at any time,
              without notice, if we believe you have violated these Terms. Upon
              termination, you must immediately stop using the App and delete
              any copies you have made. Certain provisions of these Terms,
              including but not limited to intellectual property rights,
              limitations of liability, and indemnification, will survive
              termination.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Disclaimers
            </h2>
            <p style={{ textAlign: "left" }}>
              The App is provided on an "as-is" and "as-available" basis. We do
              not make any warranties, express or implied, regarding the App’s
              operation, availability, or functionality. We disclaim all
              warranties to the fullest extent permitted by law, including
              implied warranties of merchantability, fitness for a particular
              purpose, and non-infringement.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Limitation of Liability
            </h2>
            <p style={{ textAlign: "left" }}>
              To the fullest extent permitted by applicable law, AgentPro
              Technology Businesses shall not be liable for any indirect,
              incidental, special, or consequential damages, including but not
              limited to loss of profits, data, or business, arising from your
              use or inability to use the App, even if we have been advised of
              the possibility of such damages.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Indemnification
            </h2>
            <p style={{ textAlign: "left" }}>
              You agree to indemnify and hold harmless AgentPro Technology
              Businesses, its affiliates, directors, employees, and agents from
              any claims, damages, losses, liabilities, or expenses (including
              attorney’s fees) arising from your use of the App, violation of
              these Terms, or infringement of any rights of a third party.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Changes to the Terms
            </h2>
            <p style={{ textAlign: "left" }}>
              We reserve the right to modify these Terms at any time. If we make
              material changes, we will provide notice through the App or via
              email. Your continued use of the App after such changes
              constitutes your acceptance of the revised Terms.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Governing Law
            </h2>
            <p style={{ textAlign: "left" }}>
              These Terms shall be governed by and construed in accordance with
              the laws of Lagos state, without regard to its conflict of law
              principles. Any disputes arising under or in connection with these
              Terms will be resolved in the courts located in Lagos state,
              Nigeria.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Dispute Resolution
            </h2>
            <p style={{ textAlign: "left" }}>
              In the event of any dispute or claim arising out of or relating to
              these Terms or the use of the App, you agree to first attempt to
              resolve the dispute informally by contacting us at
              hi@myagentpro.ng. If the dispute cannot be resolved informally,
              you agree to submit the dispute to binding arbitration in
              accordance with the rule of law.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Severability
            </h2>
            <p style={{ textAlign: "left" }}>
              If any provision of these Terms is found to be invalid or
              unenforceable by a court of competent jurisdiction, the remaining
              provisions shall remain in full force and effect.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Entire Agreement
            </h2>
            <p style={{ textAlign: "left" }}>
              These Terms, together with our Privacy Policy, constitute the
              entire agreement between you and AgentPro Technology Businesses
              regarding the use of the App and supersede all prior agreements or
              understandings, whether written or oral, relating to such use.
            </p>
          </li>
          <li>
            <h2 style={{ marginBottom: "10px", textAlign: "left" }}>
              Contact Information
            </h2>
            <p style={{ textAlign: "left" }}>
              If you have any questions or concerns about these Terms, please
              contact us at:
            </p>
            <p style={{ textAlign: "left" }}>AgentPro Technology Businesses</p>
            <p style={{ textAlign: "left" }}>Email: hi@myagentpro.ng</p>
            <p style={{ textAlign: "left" }}>Phone: 02018891876</p>
            <p style={{ textAlign: "left" }}>
              Address: The Philippi Centre, Oluwalogbon House, Plot A, Obafemi
              Awolowo Way, Before Testing Ground Bus-Stop, Alausa, Ikeja Lagos.
            </p>
          </li>
        </ol>
      </div>
      <Footer />
    </div>
  );
}

export default TermsAndCondition;
